import uniqid from 'uniqid';
import PropTypes from 'prop-types';
import { ArrowLink } from '@bwoty-web/styleguide';
import { CloudinaryPicture } from '@bwoty-web/ui-kit';

import SectionParagraph from '../../../../common/sectionParagraph';
import { imageSizes } from './roomTypeSrc';
import { createCloudinaryUrlForComponent } from '../../../../utils/cloudinary';

import './roomTypeList.scss';

const RoomTypeList = ({
  roomTypes,
  siteSettings,
  labels,
  toggleRoomInfo,
  accommodationSection,
}) => {
  const filteredRoomTypes = roomTypes.some((i) => i.bookingType === 'cp')
    ? roomTypes.filter((i) => i.bookingType === 'cp')
    : roomTypes;

  return (
    <div className="gw-room-type-list">
      {filteredRoomTypes.map((roomType) => {
        const { name, texts, images, wvId, accommodationSupplier } = roomType;

        if (!name || accommodationSupplier !== 'own') {
          return null;
        }

        const hasNoImage = !images[0]?.src;

        const roomImageMissing = accommodationSection?.images?.find(
          (i) => i.itemKey === 'roomImageMissing',
        );

        const image = images[0] || roomImageMissing?.image;
        if (hasNoImage) {
          image.cloudinaryUriTemplate = createCloudinaryUrlForComponent(siteSettings.imageDomain, roomImageMissing?.image?.mediaUrl)
          const { x, y, leftPixel, topPixel } = image.focalPoint || {};
          image.focalPoint = { x: x || leftPixel, y: y || topPixel };
        }

        const cloudinaryImage = {
          cloudinaryUriTemplate: image.cloudinaryUriTemplate,
          focalPoint: image.focalPoint,
          alt: image.alt || image.caption || '',
          size: image.size || image.dimensions || (image.width && image.height && {
            width: image.width,
            height: image.height,
          }),
        };

        return (
          <div className="gw-room-type-list-item" key={uniqid('room-type')}>
            <div className="gw-room-type-list-item__image-container">
              {hasNoImage && (
                <div className="gw-room-type-list-item__no-image-overlay">
                  <span>{labels?.roomImageMissing}</span>
                </div>
              )}
              <CloudinaryPicture
                img={cloudinaryImage}
                sizes={imageSizes}
                lazy
              />
            </div>
            <div className="gw-room-type-list-item__info-container">
              <h3 className="gw-room-type-list-item__heading">{name}</h3>
              {texts.map((paragraph) => {
                return (
                  <SectionParagraph
                    key={uniqid('room-type-paragraph')}
                    paragraph={paragraph}
                  />
                );
              })}
              <ArrowLink onClick={() => toggleRoomInfo(wvId)}>
                {labels.showRooms}
              </ArrowLink>
            </div>
          </div>
        );
      })}
    </div>
  );
};

RoomTypeList.propTypes = {
  roomTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  siteSettings: PropTypes.shape({
    imageDomain: PropTypes.string,
  }).isRequired,
  labels: PropTypes.shape({
    showRooms: PropTypes.string,
    roomImageMissing: PropTypes.string,
  }).isRequired,
  toggleRoomInfo: PropTypes.func.isRequired,
  accommodationSection: PropTypes.shape().isRequired,
};

export default RoomTypeList;
